const getKey = key => process.env.REACT_APP_STORAGE_PREFIX ? `${process.env.REACT_APP_STORAGE_PREFIX}.${key}` : key

export const set = (key, value) => localStorage.setItem(getKey(key), value)

export const get = key => localStorage.getItem(getKey(key))

export const remove = key => localStorage.removeItem(getKey(key))
